import http from '../_http'

const user = {
  //default
  summaryUser: (m) => { return http.get(`manager/management/user/summary`,m); },
  listUser: (m) => { return http.post(`manager/management/user/list`, m); },
  detailUser: (m) => { return http.get(`manager/management/user/${m.id}`); },

  //crud
  insertUser: (m) => { return http.post(`manager/management/user`, m); },
  updateUser: (m) => { return http.put(`manager/management/user`, m); },
  deleteUser: (m) => { return http.delete(`manager/management/user/${m.id}`, m); },

  //password
  passwordUser: (m) => { return http.get(`manager/management/user/reset/password/${m.id}`); },

  //ip
  ipUser: (m) => { return http.get(`manager/management/user/reset/ip/${m.id}`); },
}

export default user

export { user }